import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import OnVisible, { setDefaultProps } from 'react-on-visible';

//assets
import defaultImg from '../../images/default_img.png';

setDefaultProps({
    bounce: true,
});

export default class NextPostBtn extends Component {
    getNextBtn() {
        if (this.props.nextpost.slug) {
            if (this.props.next === 'next') {
                return (
                    <div id="next-post-btn">
                        <div className="not-appeared">
                            <div className="link-container">
                                <img
                                    src={
                                        this.props.nextpost
                                            .better_featured_image.source_url
                                    }
                                    alt={
                                        this.props.nextpost
                                            .better_featured_image.alt_text
                                    }
                                />
                                <div className="content-container">
                                    <div className="link-container__inner">
                                        <h4>
                                            {this.props.nextpost.title.rendered}
                                        </h4>
                                        <Link
                                            className="cta-btn white"
                                            to={{
                                                pathname: `/work/${this.props.nextpost.slug}`,
                                                state: {
                                                    transition: 'slideUp',
                                                },
                                            }}>
                                            Next case
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            } else {
                return (
                    <div id="header-prev-link" className="fadeIn">
                        <Link
                            to={{
                                pathname: `/work/${this.props.nextpost.slug}`,
                                state: { transition: 'slideUp' },
                            }}>
                            <span>Vorig project</span>
                        </Link>
                    </div>
                );
            }
        } else {
            return (
                <div id="next-post-btn">
                    <div className="link-container">
                        <img src={defaultImg} alt="img" />
                        <div className="content-container">
                            <div className="link-container__inner">
                                <h4>Bekijk al het werk</h4>
                                <Link
                                    className="cta-btn white"
                                    to={{
                                        pathname: `/work`,
                                        state: { transition: 'slideUp' },
                                    }}>
                                    Alle cases
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
    render() {
        return (
            <div className="nextprev-btn">
                <OnVisible className="not-appeared">
                    {this.getNextBtn()}
                </OnVisible>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Pages/NextPostBtn.jsx